// @flow
import React from 'react';
import { CLUSTER_WORKLOADS_INPUTS_FIELDNAMES } from '@streaming-projects/orgs/enums';
import { TextField } from '@src/formik-utils/FormFields';

import { CLUSTER_WORKLOAD_DETAILS_CONFIG_MAP } from '../config';

export const SPClusterWorkloadNameContainer = ({
  disabled = false,
  fluid = null,
  disableOnFormErrors = null,
}) => {
  const { backendFieldName, displayName } = CLUSTER_WORKLOAD_DETAILS_CONFIG_MAP.get(
    CLUSTER_WORKLOADS_INPUTS_FIELDNAMES.WORKLOAD_NAME
  );
  return (
    <TextField
      disableOnFormErrors={disableOnFormErrors}
      disabled={disabled}
      fieldDisplayName={displayName}
      fieldName={backendFieldName}
      fluid={fluid}
    />
  );
};
